"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _waves = _interopRequireDefault(require("@/directive/waves"));

var _moment = _interopRequireDefault(require("moment"));

var _Pagination = _interopRequireDefault(require("@/components/Pagination"));

var _PermissionPage = _interopRequireDefault(require("@/components/Page/PermissionPage"));

var _PermissionSimplePage = _interopRequireDefault(require("@/components/Page/PermissionSimplePage"));

var _httpUtils = _interopRequireDefault(require("@/utils/http-utils"));

var _dateformart = require("@/utils/dateformart");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// waves directive
// secondary package based on el-pagination
// import PermissionSimplePage from "@/components/Page/PermissionSimplePage";
var _default = {
  name: "organizationLog:view",
  extends: _PermissionPage.default,
  components: {
    Pagination: _Pagination.default,
    PermissionSimplePage: _PermissionSimplePage.default
  },
  directives: {
    waves: _waves.default
  },
  data: function data() {
    return {
      tableKey: 0,
      list: null,
      total: 0,
      listLoading: true,
      time: null,
      dialogType: "",
      timeList: [(0, _dateformart.getYesterday)(), (0, _dateformart.getYesterdayEnd)()],
      listQuery: {
        pageNum: 1,
        pageSize: 10,
        username: "",
        operation: "",
        method: "",
        startTime: "",
        endTime: ""
      }
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    dateFormat: function dateFormat(date) {
      if (date == undefined) {
        return "";
      }

      return (0, _moment.default)(date).format("YYYY-MM-DD HH:mm:ss");
    },
    getList: function getList() {
      var _this = this;

      if (!this.hasViewPermission) {
        return;
      }

      ;
      this.listLoading = true; // this.listQuery.currentUser = store.getters.account.username;

      if (!this.timeList) {
        this.listQuery.startTime = (0, _dateformart.getYesterday)();
        this.listQuery.endTime = (0, _dateformart.getYesterdayEnd)();
      } else {
        this.listQuery.startTime = this.timeList[0];
        this.listQuery.endTime = this.timeList[1];
      }

      _httpUtils.default.post("organizationLog", "list", null, this.listQuery).then(function (res) {
        _this.list = res.data.rows;
        _this.total = res.data.total;
        setTimeout(function () {
          _this.listLoading = false;
        }, 1 * 1000);
      }).catch(function (err) {
        _this.$message({
          type: "error",
          message: err.message
        });
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.pageNum = 1;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    }
  }
};
exports.default = _default;